import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { CONTACT } from "@/data/site";
import { Wordmark } from "@/components/site/Wordmark";

const LINKS = [
  { label: "Services", to: "/#services" },
  { label: "Why Us", to: "/#why" },
  { label: "Specialist", to: "/#specialist" },
  { label: "Pricing", to: "/services" },
  { label: "Contact", to: "/#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#08090B]/80 border-b border-[var(--line)]" : "bg-transparent"
      }`}
    >
      <nav className="container-x flex h-[68px] items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="group">
          <Wordmark className="text-xl sm:text-[1.6rem]" />
        </Link>

        <div className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className="text-sm font-medium text-white/75 transition-colors duration-200 hover:text-white"
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-2.5">
          <a href={CONTACT.phoneHref} data-testid="nav-call-btn" className="hidden btn-electric !px-5 !py-2.5 sm:inline-flex">
            <Phone size={15} /> {CONTACT.phone}
          </a>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="grid h-10 w-10 place-items-center rounded-full border border-[var(--line)] text-white lg:hidden"
            aria-label="Menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="border-t border-[var(--line)] bg-[#08090B]/95 px-5 pb-6 pt-2 backdrop-blur-xl lg:hidden">
          {LINKS.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block border-b border-[var(--line)] py-3.5 text-base font-medium text-[var(--white)]"
            >
              {l.label}
            </Link>
          ))}
          <a href={CONTACT.phoneHref} className="btn-electric mt-4 w-full">
            <Phone size={15} /> Call {CONTACT.phone}
          </a>
        </div>
      )}
      {pathname === "/services" && null}
    </header>
  );
};
